<template>
  <!-- footer block -->
  <div class="div">
    <div class="footer-area pt-100 pb-70">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="footer-logo-area">
              <h3>About Us</h3>
              <!-- <a href="index.html"><img src="@/assets/site/images/GMLogo.webp" class="img-fluid footer-logo"
                  alt="Image" /></a> -->
              <p>
                Gracia Maria is an English training academy offering intensive coaching in IELTS, OET, PTE, German and
                Spoken English.
              </p>
              <div class="contact-list">
                <ul>
                  <li>
                    Monday &ndash; Friday: 10AM &ndash; 8PM
                  </li>
                  <li>
                    Saturday &amp; Sunday: 10AM &ndash; 2PM
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6">
            <div class="footer-logo-area">
              <h3>Address</h3>
              <p>Gracia Maria Academy<br />
                Second Floor, C3 Square<br />
                Near Navya Bakers<br />
                Above Metro Fashions<br />
                TB Junction, Angamaly</p>
              <div class="contact-list">
                <ul>
                  <li>
                    <i class="ri-mail-line"></i> <a
                      href="mailto:graciamariaacademy@gmail.com">graciamariaacademy@gmail.com</a>
                  </li>
                  <li>
                    <i class="ri-phone-line"></i> <a href="tel:+919846974695">+91 98469 74695</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-sm-6">
            <div class="footer-widjet">
              <h3>Our Location</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7853.890081263288!2d76.39552418192136!3d10.185118808726367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b08065e1961666b%3A0x9efc15dfb5a3b2cd!2sGracia%20Maria%20Academy!5e0!3m2!1sen!2sin!4v1684937332122!5m2!1sen!2sin"
                width="100%" height="240" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <!-- <div class="col-lg-2 col-sm-6">
            <div class="footer-widjet">
              <h3>Academics</h3>
              <div class="list">
                <ul>
                  <li><a href="academics.html">Canvas</a></li>
                  <li><a href="academics.html">Catalyst</a></li>
                  <li><a href="academics.html">Library</a></li>
                  <li><a href="academics.html">Time Schedule</a></li>
                  <li><a href="academics.html">Apply For Admissions</a></li>
                  <li><a href="academics.html">Pay My Tuition</a></li>
                </ul>
              </div>
            </div>
          </div> -->
        </div>
        <div class="shape">
          <!-- <img src="assets/images/shape-1.png" alt="Image" /> -->
        </div>
      </div>
    </div>

    <div class="copyright-area">
      <div class="container">
        <div class="copyright">
          <div class="row">
            <div class="col-lg-5 col-md-4">
              <div class="social-content">
                <ul>
                  <li><span>Follow Us On</span></li>
                  <li>
                    <a href="https://www.facebook.com/GraciaMariaAcademyOfEnglish/" target="_blank"><i class="ri-facebook-fill"></i></a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/graciamariaacademy/" target="_blank"><i class="ri-instagram-line"></i></a>
                  </li>
                  <!-- <li>
                    <a href="https://linkedin.com/?lang=en" target="_blank"><i class="ri-linkedin-fill"></i></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="col-lg-7 col-md-8">
              <div class="copy">
                <p>
                  Copyright © {{ currentYear }} Gracia Maria Academy.
                  All rights reserved.
                  <router-link to="/privacy-policy">Privacy Policy</router-link>.
                  Developed by

                  <a href="https://www.oracloud.in/" target="_blank" rel="noopener">Oracloud</a>
                </p>
              </div>
            </div>
            <go-top :size="50" bg-color="#a40000"></go-top>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GoTop from '@inotom/vue-go-top';
export default {
  name: "FooterBar",
  components: {
    GoTop
  },
  computed: {
    // Read at render time so the footer year never goes stale.
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style scoped>
.router-link-active {
  color: #fbb034 !important;
  border-bottom: 2px solid var(--primary);
  display: inline-block !important;
}</style>
